export default {
    // 报警消息查询接口
    getAlarmInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getAlarmInfo', params, response);
    },
    // 报警消息删除接口
    deleteAlarmInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/deleteAlarmInfo', params, response);
    },
    // 报警级别信息查询接口
    getAlarmLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getAlarmLevel', params, response);
    },
    // 报警类型信息查询接口
    getAlarmEventList(params, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/getAlarmEventList', params, response);
    },
    // 获取报警类型下拉树
    getAlarmTypeTree(params, response) {
        window.vue.$apiAxios.get('/alarmserver/alarm/getAlarmTypeTree', params, response);
    },
    // 查询树形
    findDeviceTree(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTree', params, response);
    },
    // 搜索设备
    queryDeviceOrgTreeByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTreeByName', params, response);
    },
    // 获取设备类型下拉列表
    getDeviceTypeList(params, response) {
        window.vue.$apiAxios.get('/alarmserver/alarm/getDeviceTypeList', params, response);
    },
    // 检测是否包含图片
    checkHasPicture(params, responseType, response) {
        window.vue.$apiAxios.postRequestBody('/alarmserver/alarm/checkHasPicture', params, responseType, response);
    },
    // 导出
    exportAlarmInfo(params, responseType, response) {
        window.vue.$apiAxios.downloadPost('/alarmserver/alarm/exportAlarmInfo', params, responseType, response);
    },
    getMaxLimitCount(params, response) {
        window.vue.$apiAxios.get('/alarmserver/alarm/getMaxLimitCount', params, response);
    },
    // 根据通道id查询中间件、主机信息
    getDeviceInfoByChId(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/external/getDeviceInfoByChId', params, response);
    },
    queryDeviceById(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceById', params, response);
    },
    queryProjectControlMiddleware(params, response) {
        window.vue.$apiAxios.get('/device/middleware/queryProjectControlMiddleware', params, response);
    },
    queryDeviceInfoForVideoPlayByDeviceId(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/external/queryDeviceInfoForVideoPlayByDeviceId', params, response);
    },
    // 获取列表信息
    getDictValuesByTag(params, response) {
        window.vue.$apiAxios.get('/setting/dictController/getDictValuesByTag', params, response);
    },
    //查询录像信息
    queryVideoInfo(params, responses) {
        window.vue.$apiAxios.postRequestBody('/recCenterStorage/listRecFindFile', params, responses);
    }
};
